import { PostComposer } from '@pwa/components/posts/post-composer';
import { PostsFeed } from '@pwa/components/posts/posts-feed';
import { setPendingDraft } from '@pwa/lib/chat-store';
import { postQueries } from '@pwa/queries/posts';
import { useInfiniteQuery } from '@tanstack/react-query';
import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router';
import { generateId } from 'better-auth';
import { useCallback } from 'react';

export const Route = createFileRoute('/_dashboard/org/$orgId/ws/$wsId/posts')({
	component: RouteComponent,
});

function RouteComponent() {
	const { orgId, wsId } = useParams({ from: Route.id });
	const navigate = useNavigate();

	const { data, isLoading, isError, fetchNextPage, hasNextPage, isFetchingNextPage } = useInfiniteQuery(
		postQueries.workspaceFeed(orgId, wsId),
	);
	const posts = data?.pages.flatMap((p) => p.posts) ?? [];

	const handleAskScout = useCallback(
		(body: string) => {
			const chatId = generateId(8);
			setPendingDraft(chatId, body);
			void navigate({
				to: '/org/$orgId/ws/$wsId/c/$chatId',
				params: { orgId, wsId, chatId },
			});
		},
		[navigate, orgId, wsId],
	);

	return (
		<div className='container mx-auto flex max-w-3xl flex-col gap-4 px-4 py-4 md:py-6'>
			<div className='flex flex-col gap-1'>
				<h2 className='text-base font-semibold text-foreground'>Posts</h2>
				<p className='text-xs text-muted-foreground'>Updates and announcements for this workspace.</p>
			</div>
			<PostComposer defaultWsId={wsId} />
			<PostsFeed
				organizationId={orgId}
				posts={posts}
				isLoading={isLoading}
				isError={isError}
				isFetchingNextPage={isFetchingNextPage}
				hasNextPage={hasNextPage ?? false}
				onLoadMore={() => void fetchNextPage()}
				onAskScout={handleAskScout}
			/>
		</div>
	);
}
